export default __webpack_public_path__ + "static/media/Facebook.6f7b39fe.svg";